import { useIntl } from "react-intl";
import { InfoTooltip } from "@/components/design/InfoTooltip";
import { permissionLabel } from "./access-permission-labels";

export function AccessPermissionDescription({ code, description }: { code: string; description: string }) {
  const intl = useIntl();
  const label = permissionLabel(intl, code, description);
  return <span className="inline-flex max-w-full items-start gap-2">
    <span className="min-w-0 break-words">{label}</span>
    <InfoTooltip id={`permission-info-${code}`} ariaLabel={intl.formatMessage({ id: "admin.roles.permissionDetails" }, { permission: label })}>
      <span className="block">{description}</span>
      <code className="mt-2 block text-smycles-meta">{code}</code>
    </InfoTooltip>
  </span>;
}
